import {
  routerOrderGetData
} from '@/api/api'

import {
  dateOperating
} from '@/cllib/tools'

import {
  dealGasRouteOrder
} from '@/cllib/sys_lib'

const state = {
  routerOrderGas: [],
  routerOrderGasLoading: false,
  chooseRouterOrderGas: {},
  routerOrderGasAllTank: false
}

const getters = {
  chooseRouterOrderGas: state => state.chooseRouterOrderGas,
  routerOrderGasAllTank: state => state.routerOrderGasAllTank,
  routerOrderGasLoading: state => state.routerOrderGasLoading,
  routerOrderGas: state => state.routerOrderGas
}

const actions = {
  loadRouterOrderGas ({ dispatch, getters }) {
    if (!getters.chooseRouterOrderGas) {
      return
    }
    dispatch('setRouterOrderGasLoading', true)
    let parm = {
      noPage: 1,
      sendTime: getters.adjustDate,
      endTime: dateOperating.computeDay({days: 1, date: getters.adjustDate, format: 'yy-mm-dd'}),
      gasId: getters.chooseRouterOrderGas.gasId
    }
    if (!getters.routerOrderGasAllTank) {
      parm.oilId = getters.chooseRouterOrderGas.oilTypeId
    }
    routerOrderGetData(parm).then((data) => {
      dispatch('setRouterOrderGas', dealGasRouteOrder(data))
      dispatch('setRouterOrderGasLoading', false)
    }).catch((e) => {
      dispatch('setRouterOrderGasLoading', false)
    })
  },
  setRouterOrderGasAllTank ({ commit, dispatch }, data) {
    commit('setRouterOrderGasAllTank', data)
    dispatch('loadRouterOrderGas')
  },
  setRouterOrderGas ({ commit }, data) {
    commit('setRouterOrderGas', data)
  },
  setRouterOrderGasLoading ({ commit }, data) {
    commit('setRouterOrderGasLoading', data)
  },
  setChooseRouterOrderGas ({ commit, dispatch }, data) {
    commit('setChooseRouterOrderGas', data)
    if (data.gasId && data.oilTypeId) {
      dispatch('loadRouterOrderGas')
    } else {
      dispatch('setRouterOrderGas', [])
    }
  }
}

const mutations = {
  setRouterOrderGasAllTank (state, data) {
    state.routerOrderGasAllTank = data
  },
  setRouterOrderGas (state, data) {
    state.routerOrderGas = data
  },
  setRouterOrderGasLoading (state, data) {
    state.routerOrderGasLoading = data
  },
  setChooseRouterOrderGas (state, data) {
    state.chooseRouterOrderGas = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/adjust_order/route_order_gas.js